import Scrollama from 'scrollama';

export function init() {
    let animationBlocks = document.querySelectorAll('.triggered-animation');
    if (!animationBlocks.length) {
        return;
    }

    let setupTriggeredAnimations = (lottieAnimation) => {
        // Select the element you want to apply the classes to
        const scroller = Scrollama();

        // Set up the scroller with a callback function
        scroller
            .setup({
                step: '.js-triggered-animation',
                offset: 0.8
            })
            .onStepEnter((response) => {
                let timeout = response.element.getAttribute('data-delay') ? response.element.getAttribute('data-delay') : 0;
                if (response.element.getAttribute('data-step-enter') === 'PlayLottie') {
                    setTimeout(() => {
                        if (response.element.getAttribute('data-step-leave') === 'StopLottie') {
                            response.element.seek(0);
                        }
                        response.element.play();
                    }, timeout);
                }
            })
            .onStepExit((response) => {
                if (response.element.getAttribute('data-step-leave') === 'StopLottie') {
                    // Remove the enter class and add the exit class to the element
                    response.element.pause();
                }
            });

        // Call the scroller's resize function on window resize
        window.addEventListener('resize', scroller.resize);
    };


    setupTriggeredAnimations();
}
